import { useDispatch, useSelector } from 'react-redux';
import { signInActivitiesSelector } from '../redux/selectors';
import { useEffect } from 'react';
import { getSignInActivities } from '../redux/actions';
import { PaginationData } from '@modules/HappinessModule/interfaces/PaginationData';

export const useSignInActivitiesData = (pagination: PaginationData) => {
  const dispatch = useDispatch();
  const signInActivities = useSelector(signInActivitiesSelector);

  useEffect(() => {
    dispatch(getSignInActivities(pagination));
  }, [pagination]);

  return signInActivities;
};
